import { getBankByIssuer } from '../../../iwStripeProvider/StripeHelper';
import { TRUELAYER_REPAYMENT_TYPE } from '../EarlyRepaymentHelper';
import barclaysLogo from '../images/barclays-logo.svg';
import fallbackBankLogo from '../images/fallback-bank.svg';
import greenThunderIcon from '../images/green-thunder.svg';
import lloydsLogo from '../images/lloyds-logo.svg';

export const PaymentMethodLogo = ({
    type,
    issuer,
    logoStyle
}: {
    type: string;
    issuer?: string;
    logoStyle: string;
}) => {
    if (type === TRUELAYER_REPAYMENT_TYPE) {
        return (
            <img
                src={greenThunderIcon}
                alt="green thunder icon"
                className={logoStyle}
            />
        );
    }

    const bank = getBankByIssuer(issuer);
    switch (bank.key) {
        case 'barclays':
            return (
                <img
                    src={barclaysLogo}
                    alt="barclays logo"
                    className={logoStyle}
                />
            );
        case 'lloyds':
            return (
                <img src={lloydsLogo} alt="lloyds logo" className={logoStyle} />
            );
        default:
            return (
                <img
                    src={fallbackBankLogo}
                    alt="fallback bank logo"
                    className={logoStyle}
                />
            );
    }
};
